import { offset } from '@/utils/offset.js'
import maInputRadio from '../radio'

/**
 * @module
 * @name InputImgRadio
 * @extends inputRadio
 */
export default {
  name: 'inputImgRadio',
  extends: maInputRadio,

  /**
   * @property {Array} options Options array, should contain at least key, value
   *                           per option.
   * @property {String} imgPath Image name, to be found in ./assets/.
   */
  props: {
    options: {
      type: Array,
      required: true
    },
    imgPath: ''
  },

  methods: {
    /**
     * @function
     * @name getImgPath
     * @param {String} img Img name.
     */
    getImgPath (img) {
      let S3_URL
      S3_URL = process.env.S3_URL
      return S3_URL + img
    },

    /**
     * @function
     * @name posZoom
     * @description Manages zoom over input image radio.
     */
    posZoom () {
      let imgRadios = this.$el.querySelectorAll('.input__img')
      imgRadios.forEach(function (el) {
        let widthImg = el.offsetWidth
        let rightImg = offset(el).left + widthImg
        let toRightWindow = window.innerWidth - rightImg
        let zoomImg = el.parentNode.querySelector('.input__img__zoom')

        zoomImg.style.right = 'auto'
        zoomImg.style.left = (widthImg / 10) + 'rem'

        if (toRightWindow <= 344 + 20) {
          zoomImg.style.left = 'auto'
          zoomImg.style.right = (widthImg / 10) + 'rem'
        }
      })
    },
    /**
     * @function
     * @name isChecked
     * @description Returns if inputKey matches with component selected value.
     * @param {inputKey} inputKey Object key.
     */
    isChecked: function (inputKey) {
      return this.value === inputKey
    },
    /**
     * @function
     * @name handleClick
     * @description Emits an event to be captured by parent component.
     * @param {String} inputKey Clicked object key.
     */
    handleClick: function (inputKey) {
      this.$emit('change', inputKey)
    }
  },
  /**
   * @function
   * @name mounted
   * @description Added handler for resize event. When resize event is triggered,
   *              posZoom is executed.
   */
  mounted () {
    let that = this
    this.posZoom()
    window.onresize = function () {
      that.posZoom()
    }
  }
}
